<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import CommonTopGo from "@/components/common_top/common_top.vue"
import commonTop from '@/components/commonTop1.vue'
import PhotographyContributionDetail from '../photography-contribution-detail/view.vue'
import moment from 'moment'
import { hasAccess } from '@/common/utils'

export default {
    props: {
        type: {
            type: Number,
            default: 9
        }
    },
    name: 'photographyContribution',
    components: {
        commonTop,
        PhotographyContributionDetail,
        CommonTopGo
    },
    data() {
        return {
            hasAccess,
            range: [],
            commonTopData: {
                "pageName": "photographyContribution",
                "commonleftbtn": [],
                "commonbottombtn":[],
                "option":[],
                'tabnums':0,
                'mintabnums': 0,
            },
            tableData: [],
            examineTable: [],

            currentPage: 1,
            pageSize: 50,
            total: 0,
            sortField: '',
            filterDrawer: false,
            filter: {},
            checkStatus: '0',
            drawTypes: [],
            examineState: {"0": "待审核", "1": "审核通过", "-1": "审核驳回", "-2": "失效或撤回", "-3": "回退"},
            projectStatus: [
                {
                    label: '待审核',
                    value: '0',
                    children: [
                        {
                            value: '0',
                            label: '待审1/4',
                        },
                        {
                            value: '1',
                            label: '待审2/4',
                        },
                        {
                            value: '2',
                            label: '待审3/4',
                        },
                        {
                            value: '3',
                            label: '待审4/4',
                        },
                    ],
                },
                {
                    label: '审核通过',
                    value: '1',
                },
                {
                    label: '审核驳回',
                    value: '-1',
                },
                {
                    label: '失效或撤回',
                    value: '-2',
                },
            ],
            currentOperation: {},

            // 批量选择
            batch: false,
            // 全选
            isAllCheck: false,
            // 已选card
            checkeds: {},
            showDetail: false,
            // 是否显示详情操作按钮
            showDetailOperation: true,
            loading: false,
            isShowExamineTab: false,
            is_show_top:false,
            showImgSrc:'',
            showImg:false
        };
    },
    mounted(){
        this.$refs.table.bodyWrapper.addEventListener('scroll', (e) => {
            if(e.target.scrollTop>=500){
                this.is_show_top = true
            }else{
                this.is_show_top = false
            }	
        })
    },
    methods: {
        setS1(u){
            if(u.indexOf('?')){
                this.showImgSrc = u
            }else{
                this.showImgSrc = u+'?x-oss-process=image/resize,m_lfit,h_120,w_120'
            }
            this.showImg = true;
        },
        setS2(){
            this.showImgSrc = '';
            this.showImg = false;
        },
        backtop(){
            this.$refs.table.bodyWrapper.scrollTop = 0;
        },
        batchExamineClick(type) {
            if(Object.keys(this.checkeds).length) {
                this.$refs.batchExamine.checkClick(type)
            }else {
                this.$message.error('请选择审核项')
            }
        },
        init() {
            this.activeDrawTypes()
            this.isShowExamineTab = this.isShowExamine()
            this.photoworkReviewList()
        },
        async photoworkReviewList() {
            this.loading = true

            try {
                let access = JSON.parse(localStorage.getItem("access"));
                let { projectStatus, ...otherFilter } = this.filter
                projectStatus = projectStatus || []

                let params = Object.assign({
                    createdAtStart: this.range && this.range[0] ? moment(this.range[0]).format('YYYY-MM-DD HH:mm:ss') : undefined,
                    createdAtEnd: this.range && this.range[1] ? moment(this.range[1]).format('YYYY-MM-DD 23:59:59') : undefined,
                    page: this.currentPage,
                    limit: this.pageSize,
                    type: this.type,
                    checkStatus: this.checkStatus === 'all' ? undefined : this.checkStatus,
                    mixBlens: this.checkStatus === '0' ? JSON.stringify(this.getSsaa(access.top_banner).contribution_work) : undefined,
                    projectStatus: projectStatus[0],
                    checkSteps : projectStatus[1] || undefined
                }, otherFilter)

                let data = await this.api.photoworkReviewList(params)
                if(data) {
                    if(+this.checkStatus === 0) {
                        this.examineTable = data.data
                    } else {
                        this.tableData = data.data
                    }

                    data.data.forEach(item => {
                        let previewPic = item.previewPic || ''

                        item.previewPic = previewPic.split(',')
                    })

                    this.total = data.total
                }
            } finally {
                this.loading = false
            }
        },
        sizeChange(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1
            this.photoworkReviewList()
        },
        currentChange(currentPage) {
            this.currentPage = currentPage
            this.photoworkReviewList()
            this.tableScrollTop()
        },
        closeFilterDrawer() {
            this.filterDrawer = false
        },
        async searchClick() {
            this.currentPage = 1

            await this.photoworkReviewList()
            this.filterDrawer = false
        },
        clearFilter() {
            this.filter = { status: '', prizeName: '' }
        },
        async activeDrawTypes() {
             let data = await this.api.activeDrawTypes({
                access_token: localStorage.getItem("access_token"),
                limit: 5000,
            });
            this.drawTypes = data
        },
        goRecord(item) {
            this.$router.push({ path: '/luck-draw/winning-record', query: { id: item.id } })
        },
        getType(typeId) {
            return this.drawTypes.find(item => +item.drawType === +typeId) || {}
        },
        tabHandleClick() {
            this.total = 0
            this.currentPage = 1

            this.clearFilter()
            this.photoworkReviewList()
        },
        detailClick(item) {
            this.$router.push({
                path: 'photography-contribution-detail',
                query: { id: item.id , photoId: item.photoId }
            })
        },
        operationSuccess() {
            this.photoworkReviewList()
        },
        reviewClick(item) {
            this.currentOperation = item
            this.$nextTick(() => {
                this.$refs.operation.checkClick()
            })
        },
        rejectClick(item) {
            this.currentOperation = item
            this.$refs.operation.showRejectDialog = true
        },
        backClick(item) {
            this.currentOperation = item
            this.$refs.operation.showBackDialog = true
        },
        viewDetail(item, showOperation = true) {
            this.showDetailOperation = showOperation
            this.currentOperation = item
            this.showDetail = true
        },
        allCheckChange(is) {
            this.$refs.batchExamine.allCheckClick(is)
        },
        isShowExamine() {
            let [ step1, step2, step3 ] = this.$route.meta.btnsAccess.edit
            let isShow = hasAccess(step1) || this.hasAccess(step2) || hasAccess(step3)

            if(!isShow) {
                this.checkStatus = '0,1'
            }
            return isShow
        }
    },
    created() {
        this.init()
    },
    activated() {
        this.init()
    },
    computed: {
        isBatch() {
            return this.batch && +this.checkStatus === 0
        }
    },
    watch: {
        batch(val) {
            if(!val) {
                this.isAllCheck = false
                this.checkeds = {}
            }
        },
        checkeds: {
            handler(val) {
                let checkedLength = Object.keys(val).length
                this.isAllCheck  = checkedLength === this.examineTable.length
            },
            deep: true
        }
    }
};
</script>
